import { render } from "./user-profile-input.vue?vue&type=template&id=2f0b76fe&scoped=true"
import script from "./user-profile-input.vue?vue&type=script&lang=js"
export * from "./user-profile-input.vue?vue&type=script&lang=js"

import "./user-profile-input.vue?vue&type=style&index=0&id=2f0b76fe&scoped=true&lang=css"

import exportComponent from "/Users/qmaura/PANOPTIC/lify-blends-recommender/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f0b76fe"]])

export default __exports__